import Vue from "vue";
// 设备识别
import device from "current-device";
const deviceIsMobile = device.mobile();

// initial state
const state = {
  isMulti: false,
  hideTabBar: false,
  isMobile: deviceIsMobile
};

// getters
const getters = {
  getSelectStatus(state) {
    return state.isMulti
  },
  hideTabBar(state) {
    return state.hideTabBar
  },
  deviceIsMobile(state) {
    return state.isMobile
  }
};

// actions
const actions = {

};

// mutations
const mutations = {
  setSelectStatus(state, payload = { status: undefined }) {
    state.isMulti = payload.status;
    return state;
  },
  setHideTabBar(state, payload = { status: false }) {
    state.hideTabBar = payload.status
    return state
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
